import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { SharedValidationPatterns } from '@app/eds';

export class FormUtil {
  // Custom Validator: check input has exceed with limit parameter special character show error message
  public static specialCharacterExeedLimit(limit: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let inputValue = control.value;
      const allFoundSpecialCharacters = inputValue?.match(
        SharedValidationPatterns.SPECIAL_PATTERN
      );
      if (
        inputValue &&
        allFoundSpecialCharacters &&
        allFoundSpecialCharacters.length >= limit
      ) {
        return { specialCharacterExceedLimit: true };
      }
      return null;
    };
  }
}
